import { Grid, Typography, Tooltip } from '@mui/material';
import FileIcon from 'assets/icons/hashtags/file-icon.svg';
import SelectionIcon from 'assets/icons/hashtags/selection-icon.svg';
import SelectionOptionIcon from 'assets/icons/hashtags/selection-option-icon.svg';
import { EntryComponentProps } from '@draft-js-plugins/mention/lib/MentionSuggestions/Entry/Entry';
import { styles } from './styles';
import { HashtagMentionTypeEnum } from 'redux-store/api/activity-feed/hashtags.types';

const iconsMap = {
  [HashtagMentionTypeEnum.fileCabinetItem]: { color: '#CCFFDB', icon: <FileIcon /> },
  [HashtagMentionTypeEnum.phaseItem]: { color: '#CCFFDB', icon: <FileIcon /> },
  [HashtagMentionTypeEnum.selection]: { color: '#FFF9E5', icon: <SelectionIcon /> },
  [HashtagMentionTypeEnum.selectionOption]: { color: '#FFE7E1', icon: <SelectionOptionIcon /> },
};

export const HashtagEntry = ({
  mention,
  theme,
  searchValue,
  isFocused,
  selectMention,
  ...props
}: EntryComponentProps) => {
  const { color, icon } = iconsMap[mention?.type];

  return (
    <Grid {...props} sx={styles.root}>
      <Grid sx={styles.container}>
        <Grid sx={styles.iconWrapper(color)}>{icon}</Grid>

        <Tooltip title={mention?.name || ''}>
          <Typography sx={styles.text}>{mention?.name}</Typography>
        </Tooltip>
      </Grid>
    </Grid>
  );
};
